module.exports = __webpack_public_path__ + "static/media/turn.0e8e56dc.png";